/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useStandUp } from '../contexts/StandUpContext';
import TaskDetailView from './TaskDetailView';

const TaskDetailModal: React.FC = () => {
    const { 
        isDetailModalOpen, 
        closeDetailModal, 
        viewingDetailTask
    } = useStandUp();

    // Handle Escape Key
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                closeDetailModal();
            }
        };
        if (isDetailModalOpen) window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isDetailModalOpen, closeDetailModal]);

    if (!isDetailModalOpen || !viewingDetailTask) return null;

    return (
        <div className="fixed inset-0 z-[115] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={closeDetailModal}>
            <div 
                className="bg-white dark:bg-gray-900 w-full max-w-lg h-full max-h-[90vh] rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-95 duration-200 flex flex-col"
                onClick={e => e.stopPropagation()}
            >
                <TaskDetailView taskId={viewingDetailTask.id} onClose={closeDetailModal} />
            </div>
        </div>
    );
};

export default TaskDetailModal;
